import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "@/lib/i18n.ts";

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
